import { Link, useMatch } from "react-router-dom";

import { ICounters } from "@/Common/Models/MyleMenu/Tooltip/ICounters";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { MyleTabKey } from "../../Models/MyleMenu/enums/MyleTabKey";
import { MyleMenuTabItem } from "../../Models/MyleMenu/MyleMenuTabItem";
import { MyleMenuCounterTooltip } from "./MyleMenuCounterTooltip";

import "./MyleMenu.css";
/// <reference path="../../../../lib/react-router/react-router.d.ts" />

interface IMyleMenuProps {
    Tabs: MyleMenuTabItem[];
}

class MyleMenuState {
    public mobileMenuVisible: boolean;
}

class MyleMenu extends React.Component<IMyleMenuProps, MyleMenuState> {
    private timer: number;

    constructor(props: IMyleMenuProps) {
        super(props);

        const initialState = new MyleMenuState();
        initialState.mobileMenuVisible = false;
        this.state = initialState;
    }

    public render(): JSX.Element {
        let renderedTabs = this.props.Tabs.map(tab => (
            <MyleMenuTab tab={tab} key={tab.key} />
        ));

        return (
            <div className="myle-menu" onClick={e => this.stopPropagation(e)}>
                <ul className="myle-nav no-margin myle-header">{renderedTabs}</ul>
                <div className="mobile-menu-btn">
                    <span onClick={() => this.toggleMobileMenu()} className={`glyphicon glyphicon-menu-hamburger ${this.state.mobileMenuVisible ? "active" : ""}`} />
                </div>

                <div className={`mobile-menu ${!this.state.mobileMenuVisible ? "collapsed" : ""}`}>
                    <ul>
                        {renderedTabs}
                    </ul>
                </div>
                <div className="header-version">{sessionStore.versionNumber}</div>
            </div>
        );
    }

    private hideMobileMenu(): void {
        var self = this;
        self.timer = window.setTimeout(
            () => {
                var s = new MyleMenuState();
                s.mobileMenuVisible = false;
                self.setState(s);
                $(".white-background").off("click.menu");
            },
            100
        );
    }

    private stopPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private toggleMobileMenu(): void {
        clearTimeout(this.timer);
        var self = this;
        var s = new MyleMenuState();
        s.mobileMenuVisible = !this.state.mobileMenuVisible;
        if (s.mobileMenuVisible) { $(".white-background").on("click.menu", self.hideMobileMenu.bind(self)); }
        else { $(".white-background").off("click.menu"); }
        this.setState(s);
    }
}

function MyleMenuTab(props: { tab: MyleMenuTabItem }): JSX.Element {
    const isActive = useMatch({ path: props.tab.path, end: true });
    const label = cacheStore.GetString(props.tab.key);
    const isTopCounterSideExist = sessionStore.canReceiveFaxes() && props.tab.topCountUnmanagedFaxes > 0;

    const renderTooltip = (): JSX.Element => {
        let counters: ICounters;

        switch (props.tab.key) {
            case MyleTabKey.Communications:
                counters = props.tab.tooltip?.communicationsCounters;
                break;
            case MyleTabKey.LabResults:
                counters = props.tab.tooltip?.resultsCounters;
                break;
            case MyleTabKey.PrescriptionRenewals:
                counters = props.tab.tooltip?.prescriptionRenewalsCounters;
                break;
            case MyleTabKey.Documents:
                counters = props.tab.tooltip?.documentsCounters;
                break;
            case MyleTabKey.Portfolio:
                counters = props.tab.tooltip?.portfolioCounters;
                break;
            default:
                counters = null;
                break;
        }

        if (counters?.showCounters())
            return (
                <MyleMenuCounterTooltip
                    counters={counters?.getCounters()}
                    anchor={`.${props.tab.key}`}
                />
            );
    };

    if (props.tab.isLocked) {
        return (
            <li className="disabledMenuItem" data-cy={`nav-tab-${props.tab.path}`}>
                <a className="disabledLink">{label}</a>
            </li>
        );
    }
    else {
        const firstSlashIndex = props.tab.path.indexOf("/");
        const to = (isActive && firstSlashIndex !== -1)
            ? `/${props.tab.path.substring(0, firstSlashIndex)}` // get default path if current tab is sub-route
            : `/${props.tab.path}`;

        return (
            <>
                <li className={`${(isActive ? "active" : "")} ${props.tab.key}`} data-cy={`nav-tab-${props.tab.path}`}>
                    {props.tab.showCounts && (
                        <>
                            <div className="top-counters">
                                {props.tab?.topPendingCount > 0 && <div className="counter top-pending-counter" data-cy={`tab-top-pending-counter-${props.tab.key.toString()}`}>{props.tab.topPendingCount}</div>}
                                {props.tab.topCount > 0 && <div className={`${isTopCounterSideExist ? "top-counter top-counter-margin" : "top-counter"}`} data-cy={`tab-top-counter-${props.tab.key.toString()}`}>{props.tab.topCount}</div>}
                                {isTopCounterSideExist && <div className="counter top-counter-aside">{props.tab.topCountUnmanagedFaxes}</div>}
                            </div>
                            <div className="bottom-counters">
                                {props.tab?.bottomUrgentPendingCount > 0 && <div className="counter bottom-pending-counter">{props.tab?.bottomUrgentPendingCount}</div>}
                                {props.tab.bottomCount > 0 && <div className="counter bottom-counter" data-cy={`tab-bottom-counter-${props.tab.key.toString()}`}>{props.tab.bottomCount}</div>}
                                {sessionStore.canReceiveFaxes() && props.tab.bottomCountUrgentUnmanagedFaxes > 0 && <div className="counter bottom-counter-aside">{props.tab.bottomCountUrgentUnmanagedFaxes}</div>}
                            </div>
                        </>
                    )}
                    <Link
                        to={to}
                        onClick={() => {
                            if (props.tab.key === MyleTabKey.Calendar) {
                                sessionStore.dispatch(LocalOperations.Calendar.ShowNoticeBoard, { showNoticeBoard: false });
                            }
                            else if (props.tab.key === MyleTabKey.Patients) {
                                sessionStore.dispatch(LocalOperations.Person.LoadFile, { person: sessionStore.selectedFile });
                            }
                        }}
                    >{label}
                    </Link>
                </li>
                {props.tab.showCounts && renderTooltip()}
            </>
        );
    }
}

export { MyleMenu };
